<template>
  <div>
    <div class="order-main">
      <div style="font-size: small">{{ orderInfo.taskName }}</div>
      <van-divider dashed style="color: #4d84e2;margin: 3px;"></van-divider>
      <div class="order-first-div">
        <div>
          <van-icon :name="getIcon(orderInfo.taskName)"/>
          <span>{{ orderInfo.taskName }}</span>
        </div>
        <div>
          <span style="color: orangered">{{ orderInfo.orderStatus }}</span>
        </div>
      </div>
      <van-divider style="color: #4d84e2;margin: 5px;"></van-divider>
      <div class="order-first-div">
        <div>
          <van-button disabled size="mini" type="default" style="margin: 5px;">{{ orderInfo.tasktype }}</van-button>
          <van-button disabled size="mini" type="info" style="margin: 5px;">平台返款</van-button>
          <van-button disabled size="mini" type="primary" style="margin: 5px;">{{ orderInfo.returnMoneyType }}</van-button>
        </div>
        <div v-if="orderInfo.orderStatus == '待操作'">
          <hour-second-count v-bind:remainTime="getTime" @countDowmEnd="countDowmEnd"></hour-second-count>
        </div>
      </div>
      <van-divider style="color: #4d84e2;margin: 5px;"></van-divider>
      <div v-for="(item,inx) in orderInfo.taskOrderDetailGoodsVos" :key="inx">
        <van-card :title="item.mainKey">
          <template #thumb>
            <div :style="{'background-image': 'url('+getThumbUrl(item.thumbUrl)+')','background-size':'100%, 100%'}" class="van-image">
              <van-image :src="require('../../assets/img/jing.png')" style="margin: 2%;"/>
            </div>
          </template>
          <template #tags>
            <div class="end-box">
              <div class="leftArea" style="font-size: xx-small">
                <div v-if="item.isMainGood">展示价格:<span style="color: #4d84e2">{{ item.showPrice }}</span>元</div>
                <div v-if="item.getGoodsPersons != null" style="margin-top: 2px;">销量:<span style="color: #4d84e2">{{ item.getGoodsPersons }}</span>件</div>
                <div v-if="!item.isMainGood">
                  <div>规格: {{item.goodRule }}</div>
                </div>
              </div>
            </div>
          </template>
          <template #price>
            <div>单&nbsp;&nbsp;价:&nbsp;&nbsp;<span style="color: red">{{ item.buyPrice }}</span>&nbsp;&nbsp;元</div>
            <div v-if="item.isMainGood" style="color: red">主商品</div>
          </template>
          <template #num>
            <div style="margin-top: 2px;">购买数量:<span style="color: red">{{ item.buyNumbers }}</span>件</div>
          </template>
        </van-card>
      </div>
      <div style="margin-top: 5px;font-size: small;">任务类型：<span style="color: #44b1eb">{{ orderInfo.taskName }}</span></div>
      <div style="font-size: small">任务状态:<span style="color: chocolate;margin-left: 1%;">{{ orderInfo.orderStatus }}<span v-if="orderInfo.orderStatus == '待审核'">({{orderTimeLimit.businessAutoReviewTime }}分钟)</span></span></div>
      <van-divider style="color: #4d84e2;margin: 5px;" v-if="orderInfo.orderStatus == '待操作'"></van-divider>
      <div style="color: chocolate;font-size: small;margin-left: 1%;" v-if="orderInfo.orderStatus == '待操作'">提示：请在{{orderTimeLimit.verifyShowTimeLimit}}分钟内核对店铺名称</div>
      <van-divider style="color: #4d84e2;margin: 5px;" v-if="isOrderStatusReview(orderInfo)"></van-divider>
      <div style="color: red;font-size: small;margin-left: 1%;" v-if="isOrderStatusReview(orderInfo)">提示：等待物流签收评价</div>
      <van-divider style="color: #4d84e2;margin: 5px;" v-if="isOrderStatusReview(orderInfo)"></van-divider>
      <div style="color: red;font-size: small;margin-left: 1%;" v-if="isOrderStatusReview(orderInfo)">备注：确认订单物流已经签收后再评价</div>
      <van-divider style="color: #4d84e2;margin: 5px;"></van-divider>
      <div style="width: 100%;display: flex;flex-flow: row nowrap; justify-content: space-around">
        <van-button size="small" type="primary" style="margin:0 2%; width: 100%" v-if="orderInfo.orderStatus == '待操作'" @click="operationOrder">操作任务</van-button>
        <van-button size="small" type="default" style="margin:0 2%;width: 100%" @click="goToAppealCenter">申诉任务</van-button>
        <van-button size="small" type="info" style="margin:0 2%;width: 100%" @click="countDowmEnd" v-if="orderInfo.orderStatus == '待操作'">取消任务</van-button>
        <van-button size="small" type="info" style="margin:0 2%;width: 100%" @click="reviceTask" v-if="isOrderStatusReview(orderInfo)" :disabled="orderInfo.waitReviewTime>0">评价任务<span v-if="orderInfo.waitReviewTime>0">({{transferTimeTohhmmss(orderInfo.waitReviewTime)}})</span></van-button>
      </div>
      <div>
        <van-steps direction="vertical" :active="getActive">
          <van-step v-for="(it, index) in steps" :key="index">
            <step-component :pdata="it" :list="it.b2cOrderOpcontents" :active="getActive"></step-component>
          </van-step>
        </van-steps>
      </div>
    </div>
  </div>
</template>

<script>
import StepComponent from "../../components/StepComponent";
import {getReciveOrderDetail, cancelOrder} from "../../api/system/mobile_taskorder";
import {MessageBox} from "mint-ui";
import HourSecondCount from "../../components/HourSecondCount";
import {getOrderOpreationTime} from "../../api/system/sys_backInfo";

export default {
  name: "TaskDetail",
  components: {
    StepComponent,
    HourSecondCount
  },
  data() {
    return {
      orderInfo:{
      },
      timer:null,
      orderTimeLimit:{

      },
      icons: [
        {
          id: 1,
          icon: require("../../assets/img/0.png")
        },
        {
          id: 2,
          icon: require("../../assets/img/1.png")
        },
        {
          id: 3,
          icon: require("../../assets/img/2.png")
        },
        {
          id: 4,
          icon: require("../../assets/img/3.png")
        },
        {
          id: 5,
          icon: require("../../assets/img/5.png")
        }
      ],
      steps: [
        {
          idNum: "1",
          stepTitle: "操作任务",
          dateTime: "2021/4/13 13:59:25",
          isStepsAction:true,
          listData:[
            {
              orderKey:"订单编号",
              orderVal: "2106868"
            },
            {
              orderKey:"买号",
              orderVal: "Love2106868"
            },
          ],
        },
        {
          idNum: "2",
          stepTitle: "操作任务",
          dateTime: null,
          isStepsAction:true,
          listData:[
            {
              orderKey:"订单编号",
              orderVal: "2106868"
            },
            {
              orderKey:"买号",
              orderVal: "Love2106868"
            },
          ],
        },
        {
          idNum: "3",
          stepTitle: "操作任务",
          dateTime: null,
          isStepsAction:false,
          listData:[
            {
              orderKey:"订单编号",
              orderVal: ""
            },
            {
              orderKey:"买号",
              orderVal: ""
            },
          ],
        }
      ],
      active: -1,
    }
  },
  computed:{
    isOrderStatusReview(){
      return function (orderInfo) {
        if (orderInfo.orderStatus == '待评价' || orderInfo.orderStatus == '催评中'){
          return true;
        }else{
          return false;
        }
      }
    },
    getThumbUrl(){
      return function (url) {
        if (url !== undefined) {
          url = (url.substr(0, 5).toLowerCase() == "http:" || url.substr(0, 6).toLowerCase() == "https:") ? url : "http:" + url;
          return url;
        }
      }
    },
    getIcon() {
      return function (taskName) {
        let id = 1;
        if (taskName.includes("淘")){
          id = 1
        }else if (taskName.includes("京")){
          id = 2;
        }else if (taskName.includes("拼")){
          id = 3;
        }else if(taskName.includes("抖音")){
          id = 4;
        }else if (taskName.includes("阿里巴巴")){
          id = 5;
        }
        for (let i of this.icons) {
          if (i.id == id) {
            return i.icon
          }
        }
        return null;
      }
    },
    getTime(){
      return this.orderInfo.orderStatus == '待操作'?this.$store.getters.getOrderTimeLimit.opTimeLimit:null;
    },
    getActive(){
      if (this.orderInfo.orderStatus == '已取消'){
        return -1;
      }else{
        let activeTmp = 0;
        for (let i in this.steps){
          if (this.steps[i].isStepsAction){
            activeTmp = i;
          }
        }
        return activeTmp;
      }
    },
    transferTimeTohhmmss(){
      return function (second) {
        if (second < 60) {
          if (second < 10) {
            return "00:00:0" + second;
          } else {
            return "00:00:" + second;
          }
        } else {
          var min_total = Math.floor(second / 60);	// 分钟
          var sec = Math.floor(second % 60);	// 余秒
          if (min_total < 60) {
            if (min_total < 10) {
              if (sec < 10) {
                return "00:0" + min_total + ":0" + sec;
              } else {
                return "00:0" + min_total + ":" + sec;
              }
            } else {
              if (sec < 10) {
                return "00:" + min_total + ":0" + sec;
              } else {
                return "00:" + min_total + ":" + sec;
              }
            }
          } else {
            var hour_total = Math.floor(min_total / 60);	// 小时数
            if (hour_total < 10) {
              hour_total = "0" + hour_total;
            }
            var min = Math.floor(min_total % 60);	// 余分钟
            if (min < 10) {
              min = "0" + min;
            }
            if (sec < 10) {
              sec = "0" + sec;
            }
            return hour_total + ":" + min + ":" + sec;
          }
        }
      }
    }

  },
  mounted() {
    this.$emit("titleChange", "任务详情");
    //console.log(this.$route.query)
    getOrderOpreationTime({orderNumber:this.orderInfo.orderNumbers, b2cTaskTypeId:this.$route.query.b2cTaskTypeId}).then(res=>{
      if (res.success){
        //console.log("11111",res.data)
        this.orderTimeLimit = res.data;
        //if (this.$store.getters.getOrderTimeLimit.opTimeLimit == 0){
          this.orderTimeLimit.operationTimeLimit = this.orderTimeLimit.operationTimeLimit * 60;
          this.orderTimeLimit.orderTimeLimit = this.orderTimeLimit.orderTimeLimit * 60;
          this.$store.commit("updateOrderTimeLimit", this.orderTimeLimit);
        //}
        this.$forceUpdate();
      }
    });
    /*
    getReciveOrderDetail(this.$route.query).then(res=>{
      if (res.success){
        this.setData(res.data);
      }
    }).catch(err => {
      MessageBox({
        title: '提示',
        message: err.message,
        showCancelButton: true
      });
    });
    */
  },
  methods:{
    operationOrder(){
      this.$router.push({path:'/home/useroptask', query:this.orderInfo});
    },
    goToAppealCenter(){
      //console.log(this.orderInfo)
      this.$router.push({path: '/home/userorderappeal', query:this.orderInfo});
    },
    setData(data){
      //console.log(data)
      this.orderInfo = data;
      this.steps = data.b2cOrderOperationInfos
      //如果是待评价则启动定时器
      if (this.orderInfo.waitReviewTime > 0){
        this.countWaitReviewTimeLimit();
      }else{
        clearInterval(this.timer)
      }
    },
    reviceTask(){
      this.$router.push({path:'/home/reviewopt', query:this.orderInfo});
    },
    countDowmEnd(){
      //console.log("countDowmEnd end!")
      cancelOrder(this.$route.query).then(res=>{
        if (res.success){
          this.$store.commit("updateOrderTimeLimit", {operationTimeLimit:0});
          this.$router.back();
        }
      }).catch(err => {
        MessageBox({
          title: '提示',
          message: err.message,
          showCancelButton: true
        });
      });
    },
    countWaitReviewTimeLimit() {
      var self = this;
      clearInterval(this.timer)
      this.timer = setInterval(function () {
        if (self.orderInfo.waitReviewTime > 0) {
          self.orderInfo.waitReviewTime = self.orderInfo.waitReviewTime - 1;
        }
      }, 1000);
    }
  },
  beforeRouteEnter(to, from, next){
    //console.log(to, from, next)
    getReciveOrderDetail(to.query).then(res=>{
      if (res.success){
        next(vm => vm.setData(res.data));
      }
    }).catch(err => {
      MessageBox({
        title: '提示',
        message: err.message,
        showCancelButton: true
      });
    })
  }
}
</script>

<style lang="scss" scoped>
.order-main {
  margin: 10px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  width: 98%;

  .order-first-div {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    font-size: small;
  }

  .end-box{
    font-size: small;
  }
}
</style>
